<template>
  <div>
    <slot name="nav">
      <WizardNav v-bind="navProps" />
    </slot>

    <slot :transitioning="transitioning"></slot>
  </div>
</template>

<script>
import { pick } from 'lodash-es';
import {
  mapInstanceActions as mapActions,
  mapInstanceGetters as mapGetters,
  mapInstanceState as mapState
} from '@urbn/vuex-helpers';
import { SCOPED_ID_PREFIX_KEY, STORE_NAMESPACE_KEY, WIZARD } from './const';
import storeModule from '../../store/modules/formWizard';
import WizardNav from './WizardNav';
import { GO_TO_STEP } from '../../store/modules/formWizard/actions';
import { ACTIVE_STEP_NAME } from '../../store/modules/formWizard/getters';
import { IS_TRANSITIONING } from '../../store/modules/formWizard/state';

let id = 0;

export default {
  provide() {
    return {
      [WIZARD]: this,
      [SCOPED_ID_PREFIX_KEY]: this[STORE_NAMESPACE_KEY],
      [STORE_NAMESPACE_KEY]: this[STORE_NAMESPACE_KEY]
    };
  },

  props: {
    ...WizardNav.props,

    activeStep: String
  },

  components: { WizardNav },

  computed: {
    ...mapGetters((vm) => vm[STORE_NAMESPACE_KEY], [
      ACTIVE_STEP_NAME
    ]),

    ...mapState((vm) => vm[STORE_NAMESPACE_KEY], {
      transitioning: IS_TRANSITIONING
    }),

    navProps() {
      return pick(this.$props, Object.keys(WizardNav.props));
    }
  },

  methods: {
    ...mapActions((vm) => vm[STORE_NAMESPACE_KEY], [
      GO_TO_STEP
    ])
  },

  watch: {
    activeStep(val) {
      this[GO_TO_STEP](val);
    },

    [ACTIVE_STEP_NAME](val) {
      this.$emit('update:activeStep', val);
    }
  },

  beforeCreate() {
    this[STORE_NAMESPACE_KEY] = `form-wizard-${id++}`;

    if (!this.$store) throw new Error('Vuex store not available.');

    if (!this.$store.hasModule(this[STORE_NAMESPACE_KEY])) {
      this.$store.registerModule(this[STORE_NAMESPACE_KEY], storeModule);
    }
  }
};
</script>
